var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({attrs:{"options":_vm.options,"props":{
    value: 'Id',
    label: 'Name',
    checkStrictly: true,
    emitPath: false,
  }}},'el-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }